import { ModuleCreate } from './ModuleCreate'
import { ModuleEdit } from './ModuleEdit'
import { ModuleList } from './ModuleList'
import { ModuleShow } from './ModuleShow'

export { ModuleCreate, ModuleEdit, ModuleList, ModuleShow }
